import * as React from 'react';
import { useEffect } from 'react';
import Top from "../Top";
import Bottom from "../Bottom";
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import { useLocation, useNavigate } from "react-router-dom";
import { selfQuestionnaires } from "../../utils/selfQuestionnaires";

import CheckMain from "./CheckMain";

const SelfScore = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { selfQuestionNo, selfQuestionOriginalPoint, selfQuestionTypePoint } = state;

  useEffect(() => {

    return () => {
    }
  }, []);



  return (

    <Container sx={{ width: '100%', minWidth: 320, background: '#F1F2F4', p: 0, pb: 7, boxSizing: 'border-box' }} >
      <Top title="자가진단 결과" />

      <Box sx={{ pl: 2, pr: 2, }}>

        <Box sx={{ p: 2, pt: 8, mt: 2 }}>
          <Typography component="div" sx={{ fontSize: 18, color: '#555', textAlign: 'center', fontWeight: 700, mb: .5 }}>
            {selfQuestionnaires && selfQuestionnaires.filter((v: any) => v.no === selfQuestionNo)[0].title}
          </Typography>
          <Typography component="div" sx={{ fontSize: 16, color: '#777', textAlign: 'center', fontWeight: 700 }}>
            자가진단
          </Typography>
        </Box>

        <Box sx={{ bgcolor: '#fff', p: 2, mt: 1, borderRadius: 4, boxShadow: '0px 0px 3px 1px rgba(0, 0, 0, 0.12)', }}>


          <Stack direction={'column'} justifyContent={'center'} alignItems={'center'} sx={{}}>
            <Typography component="div" sx={{ fontSize: 16, fontWeight: 700, mb: 1, color: '#555' }}>
              자신의 나이에
            </Typography>
            <Typography component="div" sx={{ fontSize: 18, fontWeight: 700, mb: 1, color: '#ff0000' }}>
              {selfQuestionOriginalPoint}  <span style={{ fontSize: 16, fontWeight: 700, color: '#555' }}>점을</span>
            </Typography>
            <Typography component="div" sx={{ fontSize: 16, fontWeight: 700, color: '#555' }}>
              더해주세요.
            </Typography>
          </Stack>

        </Box>

        {selfQuestionnaires && selfQuestionnaires.filter((v: any) => v.no === selfQuestionNo)[0].intervention.map((item: any, index: any) => (
          <React.Fragment>
            {index === 0 ? (<Typography sx={{ mt: 4, fontWeight: 700, color: '#555' }}>치료 방법</Typography>) : (null)}
            <Box sx={{ bgcolor: '#fff', p: 2, m: 0, mt: 1, borderRadius: 4, boxShadow: '0px 0px 3px 1px rgba(0, 0, 0, 0.12)', }}>
              <Typography sx={{ fontSize: 14 }}>{item}</Typography>
            </Box>
          </React.Fragment>
        ))}


        <Box sx={BtnStyle}>
          <Button variant="contained" sx={BottomBtnStyle}
            onClick={() => navigate('../check/SelfCheckList')}
          >
            확인
          </Button>
        </Box>

      </Box>



      <React.Fragment>
        <Box sx={{ bgcolor: '#fff', p: 1, pl: 2, pr: 2, mt: 8 }}>
          <Typography sx={{ fontSize: 16, fontWeight: 700, color: '#555', pt: 1, mb: 1, pl: 2, }}>추천 자가진단 </Typography>
          <CheckMain />
        </Box>
      </React.Fragment>



      <Bottom />
    </Container>
  );
}



const BtnStyle = {
  display: 'flex',
  justifyContent: 'center',
  mt: 7,
};

const BottomBtnStyle = {
  width: '100%',
  bgcolor: '#EF8322',
  fontSize: 18,
  fontWeight: 700,
  borderRadius: '30px',
  p: .5,
  boxSizing: 'border-box',
  color: '#fff',
  border: '0px solid #ef8322',
  ':hover': {
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
    boxShadow: 'none',
    color: '#fff'
  },
  ':active': {
    boxShadow: 'none',
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
  },
  ':focus': {
    boxShadow: 'none',
  },
};


export default SelfScore;